const generateLocaleId = label => {
  if (!label) {
    return label;
  }
  return label
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toUpperCase();
};

export default generateLocaleId;
